export enum JobSearchSuggestion {
  LOCATION = 'Location',
  SKILLSET = 'Skillset',
}
